module.exports = __webpack_public_path__ + "img/1547386071.4474240c.jpg";